import { Outlet } from "@tanstack/react-router";

import { CommandBar } from "../CommandBar";
import { LeftRail } from "./LeftRail";
import { TopBar } from "./TopBar";

export function AppShell(): React.ReactElement {
    return (
        <div className="app-shell">
            <LeftRail />
            <TopBar />
            <main className="app-shell__main">
                <Outlet />
            </main>
            <CommandBar />
        </div>
    );
}
